import {Component, OnInit} from '@angular/core';
import {BaseDialog} from '../base-dialog';
import {NbDialogRef} from '@nebular/theme';
import {Router} from '@angular/router';

@Component({
  selector: 'app-confirm-message-dialog',
  templateUrl: './confirm-message-dialog.component.html',
  styleUrls: ['./confirm-message-dialog.component.css']
})
export class ConfirmMessageDialogComponent extends BaseDialog<ConfirmMessageDialogComponent> implements OnInit {

  title: string;
  msg: string;

  constructor(dialogRef: NbDialogRef<ConfirmMessageDialogComponent>, route: Router) {
    super(dialogRef, route);
  }

  ngOnInit() {
  }

}
